import { OwnedBanner, isConnectionOwned as isOwnedOwner } from '@/components/OwnedChip'
import { Button } from '@/components/ui/button'
import { InvoiceMetrics } from '@/pages/InvoiceHeaderActions'
import type { Invoice } from '@/pages/InvoicesPage.types'

export function isConnectionOwned(invoice: Invoice | undefined): boolean {
  return isOwnedOwner(invoice?.owner)
}

export function OwnedInvoiceBanner({ invoice }: { invoice: Invoice }) {
  return (
    <OwnedBanner
      owner={invoice.owner}
      externalUrl={invoice.external_url}
      lastSyncedAt={invoice.last_synced_at}
    />
  )
}

export function OwnedInvoiceHeaderActions({
  invoice,
  onRecordPayment,
}: {
  invoice: Invoice
  onRecordPayment: () => void
}) {
  const availability = invoice.record_payment
  const enabled = availability?.state === 'enabled'
  return (
    <div className="flex flex-wrap items-start justify-end gap-2">
      <div className="flex flex-col items-start gap-1">
        <Button type="button" size="sm" disabled={!enabled} onClick={onRecordPayment}>
          Record payment
        </Button>
        {!enabled && availability?.message && (
          <p className="max-w-[18rem] text-caption text-muted-foreground">{availability.message}</p>
        )}
      </div>
      <InvoiceMetrics invoice={invoice} />
    </div>
  )
}
